document.addEventListener("DOMContentLoaded", function () {
  if (typeof window.sortTable !== "function") {
    window.sortTable = function (colIndex) {
      const table = document.getElementById("doll-table");
      if (!table) return;

      let switching = true;
      let dir = "asc";
      let switchcount = 0;

      while (switching) {
        switching = false;
        const rows = table.rows;
        for (let i = 1; i < rows.length - 1; i++) {
          let shouldSwitch = false;
          const x = rows[i].getElementsByTagName("TD")[colIndex];
          const y = rows[i + 1].getElementsByTagName("TD")[colIndex];
          const xContent = isNaN(x.innerText) ? x.innerText.toLowerCase() : parseFloat(x.innerText);
          const yContent = isNaN(y.innerText) ? y.innerText.toLowerCase() : parseFloat(y.innerText);

          if ((dir === "asc" && xContent > yContent) || (dir === "desc" && xContent < yContent)) {
            shouldSwitch = true;
            break;
          }
        }

        if (shouldSwitch) {
          rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
          switching = true;
          switchcount++;
        } else if (switchcount === 0 && dir === "asc") {
          dir = "desc";
          switching = true;
        }
      }
    };
  }
});
